(function() {
  'use strict';

  // ===== 1. ELIMINAR DECIMALES ,00 =====
  function limpiarDecimales() {
    document.querySelectorAll('bdi, .price-item, .totals__total-value, .cart-item__final-price, .cart-item__old-price, .price__regular, .price__sale').forEach(function(el) {
      el.childNodes.forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent
            .replace(/,00(?=\s*(ARS|$))/g, '')
            .replace(/\.00(?=\s*(ARS|$))/g, '');
        }
      });
      if (el.children.length === 0) {
        el.textContent = el.textContent
          .replace(/,00(?=\s*(ARS|$|\s))/g, '')
          .replace(/\.00(?=\s*(ARS|$|\s))/g, '');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', limpiarDecimales);
  var precioObserver = new MutationObserver(function() {
    clearTimeout(window._ntPrecioTimer);
    window._ntPrecioTimer = setTimeout(limpiarDecimales, 100);
  });
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.price, .totals, .cart-item__price-wrapper').forEach(function(el) {
      precioObserver.observe(el, { childList: true, subtree: true, characterData: true });
    });
    limpiarDecimales();
  });


  // ===== 2. PAGINA DE PRODUCTO: VOLVER DESPUES DE AGREGAR =====
  document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.product__info-container')) return;
    var buyBtn = document.querySelector('.product-form__buttons [name="add"], .product-form__buttons button[type="submit"]');
    if (!buyBtn) return;
    var btnWrapper = buyBtn.closest('.product-form__buttons');
    if (btnWrapper) {
      var dynamicCheckout = btnWrapper.querySelector('.shopify-payment-button, shopify-accelerated-checkout');
      if (dynamicCheckout) dynamicCheckout.style.display = 'none';
    }
    buyBtn.addEventListener('click', function() {
      setTimeout(function() {
        if (document.referrer && document.referrer !== window.location.href) {
          history.back();
        } else {
          window.location.href = '/collections/all';
        }
      }, 800);
    });
  });


  // ===== 3. SCROLL INFINITO =====
  document.addEventListener('DOMContentLoaded', function() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // Buscar el link de siguiente pagina en cualquier parte de la pagina
    function getNextUrl() {
      return (
        document.querySelector('a[aria-label="P\u00e1gina siguiente"]') ||
        document.querySelector('a[aria-label="Next page"]') ||
        document.querySelector('a.pagination__item--prev.pagination__item-arrow')
      );
    }

    var isLoading = false;

    function observeLastItem() {
      var items = grid.querySelectorAll('.grid__item');
      if (!items.length) return;
      var lastItem = items[items.length - 1];

      var observer = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting || isLoading) return;

        var nextLink = getNextUrl();
        if (!nextLink) return;

        isLoading = true;
        observer.disconnect();

        // Mostrar indicador de carga
        var loading = document.getElementById('nt-loading');
        if (loading) loading.classList.add('visible');

        fetch(nextLink.href)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            // Agregar nuevos items
            var newItems = doc.querySelectorAll('#product-grid .grid__item');
            newItems.forEach(function(item) {
              grid.appendChild(item);
            });

            // Reemplazar paginacion completa
            var oldPagination = document.querySelector('.pagination-wrapper');
            var newPagination = doc.querySelector('.pagination-wrapper');
            if (oldPagination && newPagination) {
              oldPagination.replaceWith(newPagination);
            } else if (oldPagination) {
              oldPagination.remove();
            }

            if (loading) loading.classList.remove('visible');
            isLoading = false;
            limpiarDecimales();

            // Observar el nuevo ultimo item si hay mas paginas
            if (getNextUrl()) {
              observeLastItem();
            }
          })
          .catch(function() {
            if (loading) loading.classList.remove('visible');
            isLoading = false;
            // Reintentar observando
            observeLastItem();
          });
      }, { rootMargin: '400px' });

      observer.observe(lastItem);
    }

    // Solo activar si hay mas de una pagina
    if (getNextUrl()) {
      observeLastItem();
    }
  });

  // Exponer ntUpdateBubble globalmente para uso desde card-product
  window.ntUpdateBubble = function(itemCount) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var bubble = el.querySelector('.cart-count-bubble');
    if (itemCount === 0) { if (bubble) bubble.remove(); return; }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      el.appendChild(bubble);
    }
    var vis = bubble.querySelector('[aria-hidden]');
    if (!vis) { vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true'); bubble.insertBefore(vis, bubble.firstChild); }
    vis.textContent = itemCount < 100 ? itemCount : '99+';
    var a11y = bubble.querySelector('.visually-hidden');
    if (!a11y) { a11y = document.createElement('span'); a11y.className = 'visually-hidden'; bubble.appendChild(a11y); }
    a11y.textContent = itemCount + ' productos en carrito';
  };

})();
